var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// @ts-ignore
import axios, { AxiosError } from 'axios';
import { buildBotEngineHeaders, createMessageRequest } from "./bot-engine-contract";
var LOG_MODULE_NAME = "[Aigo_Api]";
var ApiService = /** @class */ (function () {
    function ApiService(client) {
        var _this = this;
        this.getConfigurationAsync = function () { return __awaiter(_this, void 0, void 0, function () {
            var config, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        config = { headers: this.buildHeaders(false) };
                        return [4 /*yield*/, this._aigoEndpoint.get(process.env.AIGO_CONFIGURATION_ENDPOINT, config)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_1 = _a.sent();
                        this.logError(error_1);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.sendMessageAsync = function (messageText_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([messageText_1], args_1, true), void 0, function (messageText, messageOptions) {
                var messageRequest, config, response, error_2;
                if (messageOptions === void 0) { messageOptions = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            messageRequest = createMessageRequest(messageText, this.getNextMessageOrderId(), messageOptions);
                            config = { headers: this.buildHeaders(true) };
                            return [4 /*yield*/, this._aigoEndpoint.post(process.env.AIGO_MESSAGES_ENDPOINT, messageRequest, config)];
                        case 1:
                            response = (_a.sent()).data;
                            return [2 /*return*/, response];
                        case 2:
                            error_2 = _a.sent();
                            this.logError(error_2);
                            return [2 /*return*/, null];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        this.resetMessageOrderId = function () {
            sessionStorage.setItem(_this.getMessageOrderStorageKey(), "0");
        };
        this.buildHeaders = function (hasBody) {
            var context = {
                authToken: _this.getAuthToken(),
                clientId: _this.client.clientId,
                botId: _this.client.botId,
                sessionId: _this.client.sessionId,
                userId: _this.client.userId,
            };
            return buildBotEngineHeaders(context, hasBody);
        };
        this.getNextMessageOrderId = function () {
            var storageKey = _this.getMessageOrderStorageKey();
            var currentValue = Number(sessionStorage.getItem(storageKey) || "0");
            var nextValue = currentValue + 1;
            sessionStorage.setItem(storageKey, nextValue.toString());
            return nextValue;
        };
        this.getMessageOrderStorageKey = function () {
            return "aigo-message-order-id-".concat(_this.client.botId, "-").concat(_this.client.sessionId);
        };
        this.getApiBaseUrl = function () {
            return process.env.AIGO_BASE_ENDPOINT_URL || process.env.VITE_AIGO_API_BASE_URL;
        };
        this.getAuthToken = function () {
            return process.env.AIGO_AUTH_TOKEN || process.env.VITE_AIGO_AUTH_TOKEN;
        };
        this.logError = function (error) {
            var _a;
            if (error instanceof AxiosError) {
                var status_1 = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
                var detail = _this.getErrorDetail(error);
                console.error("".concat(LOG_MODULE_NAME, " Request failed"), { status: status_1, detail: detail });
                return;
            }
            console.error("".concat(LOG_MODULE_NAME, " Request failed"), error);
        };
        this.getErrorDetail = function (error) {
            var _a;
            var data = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
            if (data === null || data === void 0 ? void 0 : data.detail) {
                return typeof data.detail === "string" ? data.detail : JSON.stringify(data.detail);
            }
            return error.message;
        };
        this._aigoEndpoint = axios.create({ baseURL: this.getApiBaseUrl() });
        this.client = client;
    }
    return ApiService;
}());
export { ApiService };
